<template>
  <vx-card title="Hak Akses Pengguna" class="mt-base">
    <table>
      <tr v-for="(item, index) in allHakAkses" :key="index">
        <td>{{item.name}} &emsp;&emsp;&emsp;&emsp; </td>
        <td>
          <vs-switch v-model="hakAksesList" :vs-value="item.id" @input="setNewAkses(item.id)" :disabled="switchDisable">
            <span slot="on">Akses Aktif</span>
            <span slot="off">Akses Tidak Aktif</span>
          </vs-switch>
        </td>
      </tr>
    </table>
  </vx-card>
</template>

<script>
import { CREATE, DELETE} from '@/query/hak-akses-pengguna';
import { GET_ALL as ALL_AKSES } from "@/query/hak-akses";

export default {
  props: {
    pengguna: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      allHakAkses: [],
      hakAksesList : [],
      switchDisable : false
    }
  },
  apollo: {
    allHakAkses: {
      query: ALL_AKSES,
      update : data => data.hakAkses.data,
      variables() {
        return {
          perPage: 100,
          where: {column: "PARENTAKSES_ID", operator: "IS_NULL"}
        };
      },
      fetchPolicy: "cache-and-network",
    },
  },
  computed: {
    listHakAksesPenggunaModifier(){
      if(this.pengguna.hak_akses.length != 0){
        let hakAksesPenggunaId = this.pengguna.hak_akses.map((item) => {
          return {
            hak_akses_id: item.id,
            hak_akses_pengguna_id: item.pivot.id 
          };
        });
        return hakAksesPenggunaId;
      }
      else{
        return [];
      }
    }
  },
  watch: {
    pengguna: {
      handler(){
        if(this.pengguna.hak_akses.length != 0){
          let hakAksesList = this.pengguna.hak_akses.map((item) => {
            return item.id;
          });
          this.hakAksesList = hakAksesList;
        }
      },
      deep: true
    }
  },
  methods: {
    setNewAkses(hakAksesId){
      var check = this.hakAksesList.includes(hakAksesId.toString());
      this.switchDisable = true;
      check ? this.storeAkses(hakAksesId) : this.deleteAkses(hakAksesId);
      // console.log('listAkses', this.hakAksesList);
      // console.log('hakaksesid', hakAksesId);
      // console.log('check', this.hakAksesList.includes(hakAksesId.toString()));
    },
    async storeAkses(hakAksesId){
      // console.log('store',hakAksesId);
      await this.$apollo.mutate({
        mutation: CREATE,
        variables: {
          input: {
            hak_akses_id : hakAksesId,
            pengguna_id : this.pengguna.id 
          }
        }
      })
      .then(() => {
        // console.log('stored',hakAksesId);
        this.switchDisable = false;
        this.$emit('submitCallback');
      })
      .catch(error => {
        this.switchDisable = false;
        console.error(error);
        this.$vs.notify({
          title: "Gagal",
          text: "Terjadi kesalahan saat menghapus akses",
          color: "danger"
        });
      });
    },
    async deleteAkses(hakAksesId){
      // console.log('delete',hakAksesId);
      let hakAksesPenggunaId = this.listHakAksesPenggunaModifier.find(item => {
        return item.hak_akses_id == hakAksesId;
      }).hak_akses_pengguna_id;
      
      if(typeof hakAksesPenggunaId != 'undefined' || hakAksesPenggunaId != null){
        // console.log('deleting',hakAksesPenggunaId);
        await this.$apollo.mutate({
          mutation: DELETE,
          variables: {
            id : hakAksesPenggunaId,
          }
        })
        .then(() => {
          // console.log('deleted',hakAksesPenggunaId);
          this.switchDisable = false;
          this.$emit('submitCallback');
        })
        .catch(error => {
          this.switchDisable = false;
          console.error(error);
          this.$vs.notify({
            title: "Gagal",
            text: "Terjadi kesalahan saat menghapus akses",
            color: "danger"
          });
        });
      }
    },
  }
}
</script>